module.exports = __webpack_public_path__ + "static/media/banner-blog-oito.ad5b3e1b.jpg";